<!-- SkyPlus Reports Component -->
<div class="sp-reports-container">
  
  <!-- Header - Same as Document Library -->
  <sp-header></sp-header>

  <!-- Main Content -->
  <div class="sp-reports-main">
    
    <!-- Left Sidebar - Report Categories -->
    <aside class="sp-reports-sidebar">
      <div class="sp-sidebar-header">
        <span class="material-icons">analytics</span>
        <span>Reports</span>
      </div>
      
      <!-- Report Categories -->
      <div class="sp-report-categories">
        <div class="sp-category" *ngFor="let category of reportCategories">
          
          <!-- Category Header -->
          <div class="sp-category-header" 
               [class.expanded]="category.expanded"
               (click)="toggleCategory(category)">
            <span class="material-icons expand-icon">{{ category.expanded ? 'expand_more' : 'chevron_right' }}</span>
            <span class="material-icons category-icon">{{ category.icon }}</span>
            <span class="category-name">{{ category.name }}</span>
            <span class="report-count">{{ getReportCount(category) }}</span>
          </div>
          
          <!-- Category Reports -->
          <div class="sp-category-reports" *ngIf="category.expanded">
            <div class="sp-report-item" 
                 *ngFor="let report of category.reports"
                 [class.selected]="isReportSelected(report)"
                 (click)="selectReport(report, category)">
              <span class="material-icons report-icon">{{ report.icon }}</span>
              <span class="report-name">{{ report.name }}</span>
            </div>
          </div>
          
        </div>
      </div>
    </aside>

    <!-- Center Content - Report Display -->
    <main class="sp-reports-content">
      
      <!-- Report Header -->
      <div class="sp-report-header" *ngIf="selectedReport">
        <div class="sp-report-title">
          <span class="material-icons">{{ selectedReport.icon }}</span>
          <div class="sp-report-info">
            <h1>{{ selectedReport.name }}</h1>
            <p *ngIf="selectedReport.description">{{ selectedReport.description }}</p>
          </div>
        </div>
        <div class="sp-report-actions">
          <button class="sp-btn sp-btn-icon" title="Refresh">
            <span class="material-icons">refresh</span>
          </button>
          <button class="sp-btn sp-btn-icon" title="Export">
            <span class="material-icons">download</span>
          </button>
          <button class="sp-btn sp-btn-icon" title="Full Screen">
            <span class="material-icons">fullscreen</span>
          </button>
        </div>
      </div>

      <!-- Loading Status -->
      <div class="sp-report-status" *ngIf="statusMessages.length > 0 && isLoading">
        <div class="status-messages">
          <div *ngFor="let status of statusMessages" 
               [class.error]="status.isError" 
               [class.success]="!status.isError">
            {{ status.message }}
          </div>
        </div>
      </div>

      <!-- Error Message -->
      <div class="sp-report-error" *ngIf="errorMessage && !isLoading">
        <span class="material-icons">error_outline</span>
        <div class="error-content">
          <h3>Unable to load report</h3>
          <p>{{ errorMessage }}</p>
        </div>
      </div>

      <!-- Loading Spinner -->
      <div class="sp-report-loading" *ngIf="isLoading">
        <div class="spinner"></div>
        <p>Loading dashboard...</p>
      </div>

      <!-- Superset Dashboard Container -->
      <div id="superset-container" 
           #supersetContainer
           class="sp-superset-container"
           [class.hidden]="isLoading || errorMessage">
      </div>

      <!-- No Report Selected -->
      <div class="sp-no-report" *ngIf="!selectedReport">
        <span class="material-icons">analytics</span>
        <h2>Select a Report</h2>
        <p>Choose a report from the sidebar to view</p>
      </div>

    </main>

  </div>

</div>